import React, { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faPowerOff, faBell } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

function AdminHeader() {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const storedSubAdmin = sessionStorage.getItem("admin");
    if (storedSubAdmin) {
      setAdmin(JSON.parse(storedSubAdmin));
    } else {
      navigate("/admin"); // Redirect to login if no session data
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem("admin");
    navigate("/admin");
  };

  return (
    <>
      <div className="header" style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}>
        <Navbar expand="lg">
          <Container fluid>
            <Navbar.Brand href="#">
              <h3 style={{ color: "rgb(6 160 150)", fontWeight: "600", fontSize: "29px" }}>
                Welcome Admin
              </h3>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
              <Nav className="ms-auto my-2 my-lg-0" navbarScroll>
                {admin && (
                  <div className="d-flex align-items-center">
                    {/* Notification Icon (No Count) */}
                    {/* <FontAwesomeIcon icon={faBell} style={{ fontSize: "22px", color: "#f39c12", marginRight: "15px", cursor: "pointer" }} /> */}

                    {/* Admin Name and Email */}
                    <FontAwesomeIcon icon={faUser} style={{ fontSize: "20px", marginRight: "10px" }} />
                    <span style={{ fontSize: "17px", fontWeight: "600", color: "rgb(6 160 150)" }}>
                      {admin.name}
                      <div className="d-block" style={{ fontSize: "14px", fontWeight: "600" }}>
                        {admin.email}
                      </div>
                    </span>
                  </div>
                )}

                {/* Logout Icon */}
                <div className="ms-3" onClick={handleLogout} style={{ cursor: "pointer" }}>
                  <FontAwesomeIcon icon={faPowerOff} style={{ fontSize: "25px", marginLeft: "20px", color: "red" }} />
                </div>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
}

export default AdminHeader;
